var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAkbank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 13,
    viewBox: "0 0 110 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.966 0L0 12.255h4.324l1.012-1.82h8.202l1.012 1.82h4.41L11.993 0H6.966zm28.688 0h-5.096L26.08 4.324h-2.042V0h-3.912v12.255h3.912v-4.43h2.54l4.821 4.43h5.336L29.53 5.69 35.654 0zM51.87 5.848c.686-.386 1.44-1.103 1.44-2.574C53.31 1.26 51.887 0 49.519 0H37.799v12.255h12.114c2.402 0 4.118-1.155 4.118-3.414 0-1.943-1.27-2.783-2.162-2.993zM61.409 0l-6.967 12.255h4.324l1.013-1.82h8.201l1.012 1.82h4.41L66.436 0h-5.027zm25.634 8.544L80.23 0h-5.662v12.255h3.843V3.712l6.812 8.543h5.662V0h-3.843v8.544zm15.75-2.854L108.92 0h-5.096l-4.478 4.324h-2.042V0h-3.912v12.255h3.912v-4.43h2.54l4.82 4.43H110l-7.206-6.565zm-61.15-2.749h6.64c.72 0 1.218.263 1.218.91 0 .648-.498.876-1.218.876h-6.64V2.941zM6.965 7.528l2.47-4.447 2.489 4.447H6.966zm54.443 0l2.47-4.447 2.488 4.447H61.41zM48.746 9.314h-7.104v-1.96h7.104c.772 0 1.338.28 1.338.98s-.566.98-1.338.98z",
    transform: "translate(-281.000000, -20.000000) translate(281.000000, 20.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkbank);
export default __webpack_public_path__ + "static/media/akbank.58a0886783d6efeeab224022327fb1d6.svg";
export { ForwardRef as ReactComponent };